import { connect } from 'react-redux';
import Questions from '../../../components/event/after-action/questions';
import {
    updateAfterAction,
    approveAfterAction,
    requestInfoAfterAction,
    updateAndSubmitAfterAction,
    setEventUserAction,
    setEventErrorMessage,
    setAARecommended,
    toggleAARequestModal,
    setFormFieldValidity
} from '../../../actions';

import {
    getEventActions,
    getEventStatus,
    getEventForm
} from '../../../reducers';

const mapStateToProps = state => ({
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasAfterActionActions,
    userIsCreator: state.events.userIsCreator,
    userAction: state.events.userAction,
    approvers: state.events.aaApprovers,
    tasks: state.events.aaTasks,
    aaStatus: state.events.aaStatus,
    aaRecommended: state.events.aaRecommended,
    requestModalActive: state.events.aaRequestModalActive,
    afterActionUserID: state.event.EventReport.userId,
    groupStatus: state.events.groupStatus,
    eventState: state.event,
    eventForm: getEventForm(state)
});

const mapDispatchToProps = dispatch => ({
    updateAfterAction: data => dispatch(updateAfterAction(data)),
    approveAfterAction: data => dispatch(approveAfterAction(data)),
    requestInfoAfterAction: data => dispatch(requestInfoAfterAction(data)),
    submitAfterAction: data => dispatch(updateAndSubmitAfterAction(data)),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: msg => dispatch(setEventErrorMessage(msg)),
    setAARecommended: bool => dispatch(setAARecommended(bool)),
    toggleRequestModal: () => dispatch(toggleAARequestModal()),
    setFormFieldValidity: (model, bool) =>
        dispatch(setFormFieldValidity(model, bool))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Questions);



// WEBPACK FOOTER //
// ./src/containers/event/after-action/questions.js